const ActionTypes = {
    SET_LOADER_VISIBILITY: 'SET_LOADER_VISIBILITY'
};

function setLoaderVisibility (payload = null) {

    return {
        type: ActionTypes.SET_LOADER_VISIBILITY,
        payload
    };
}

export {
    setLoaderVisibility,
    ActionTypes
};


// WEBPACK FOOTER //
// ./src/js/store/actions/loader.js